import moment from 'moment'
moment.locale('pt-br')

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    '$moment': {
      get () {
        return moment
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/MomentVue.js